export default __webpack_public_path__ + "static/media/6.33bb8e38.jpg";